import { PhasrMonitoredRulesGridWebComponent } from './component/PhasrMonitoredRulesGridWebComponent';
import { WEB_COMPONENT_PHASR_MONITORED_RULES_GRID } from '../../webcomponents.constants';

export { PhasrMonitoredRulesGridWebComponent };

window.customElements.define(WEB_COMPONENT_PHASR_MONITORED_RULES_GRID, PhasrMonitoredRulesGridWebComponent);
